import withLabel from 'admin-components/components/withLabel/withLabel';
import FareType from './FareType';

export default withLabel(FareType);
